import { useParams } from "react-router-dom";
import { ShowById } from "src/components/ShowById";

export function ShowEgenkontroller() {
  const { inspectionId } = useParams();
  return <ShowById id={inspectionId || ""} />;
}
